<lang-change></lang-change>
<div class="container login-container">
    <div class="card card-container">
        <p id="profile-name" class="profile-name-card" i18n> Register</p>
    <form name="form" (ngSubmit)="f.form.valid && register()" #f="ngForm" novalidate>

        <div class="form-group" appDynamicDirection [ngClass]="{ 'has-error': f.submitted && !username.valid }">
            <label for="first_name" i18n>First Name</label>
            <input type="text" class="form-control" name="first_name" [(ngModel)]="model.first_name" #first_name="ngModel" required id="first_name" />
            <div *ngIf="f.submitted && !first_name.valid" class="help-block" i18n>First Name is required</div>
        </div>


        <div class="form-group" appDynamicDirection [ngClass]="{ 'has-error': f.submitted && !username.valid }">
            <label for="last_name" i18n>Last Name</label>
            <input type="text" class="form-control" name="last_name" [(ngModel)]="model.last_name" #last_name="ngModel" required id="last_name"/>
            <div *ngIf="f.submitted && !last_name.valid" class="help-block" i18n>Last Name is required</div>
        </div>

        <div class="form-group" appDynamicDirection [ngClass]="{ 'has-error': f.submitted && !username.valid }">
            <label for="email" i18n>Email</label>
            <input type="email" pattern="[^ @]*@[^ @]*" class="form-control" name="email" [(ngModel)]="model.email" #email="ngModel" required id="email"/>
            <div *ngIf="f.submitted && !email.valid" class="help-block" i18n>Please enter a valid email</div>
        </div>

        <div class="form-group" appDynamicDirection [ngClass]="{ 'has-error': f.submitted && !userrole.valid }">
            <label for="userrole" i18n>Role</label>
            <select [(ngModel)]="model.role" required id="userrole" class="form-control" name="second" #userrole="ngModel">
                <option [ngValue]="undefined" selected disabled i18n>Select a role</option>
                <option *ngFor="let role of rolelist" [value]="role.id">{{role.name}}</option>
            </select>
            <div *ngIf="f.submitted && !userrole.valid" appDynamicDirection class="help-block" i18n>Please select a role</div>
        </div>


        <div class="form-group" appDynamicDirection [ngClass]="{ 'has-error': f.submitted && !userteam.valid }">
            <label for="userteam" i18n>Country (Team)</label>
            <select [(ngModel)]="model.team" class="form-control" required id="userteam" name="first" #userteam="ngModel">
                <option [ngValue]="undefined" selected="true" disabled i18n>Select a country</option>
                <option *ngFor="let team of teamlist" [value]="team.id">{{team.name}}</option>
            </select>
            <div *ngIf="f.submitted && !userteam.valid" appDynamicDirection class="help-block" i18n>Please select a country</div>
        </div>

        <div class="form-group" appDynamicDirection [ngClass]="{ 'has-error': f.submitted && !organization.valid }">
            <label for="organization" i18n>Organization</label>
            <input type="text" class="form-control" name="organization" [(ngModel)]="model.organization" #organization="ngModel" required id="organization"/>
            <div *ngIf="f.submitted && !organization.valid" class="help-block" i18n>Organization is required</div>
        </div>

        <div class="form-group" appDynamicDirection [ngClass]="{ 'has-error': f.submitted && !username.valid }">
            <label for="username" i18n>Username</label>
            <input type="text" class="form-control" name="username" [(ngModel)]="model.username" #username="ngModel" required id="username"/>
            <div *ngIf="f.submitted && !username.valid" class="help-block" i18n>Username is required</div>
        </div>

        <div class="form-group" appDynamicDirection [ngClass]="{ 'has-error': f.submitted && !password.valid }">
            <label for="password" i18n>Password</label>
            <input type="password" class="form-control" name="password" [(ngModel)]="model.password" #password="ngModel" required id="password" />
            <div *ngIf="f.submitted && !password.valid" class="help-block" i18n>Password is required, it should have 8 characters, atleast 1 alphabet and 1 digit</div>
        </div>

        <div class="form-group" appDynamicDirection>
            <button [disabled]="loading" class="btn btn-primary btn-radius btn-block" i18n>Register</button>
            <img *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            <a [routerLink]="['/login']" class="btn btn-default btn-block btn-radius" i18n>Cancel</a>
        </div>
    </form>
</div><!-- /card-container -->
</div><!-- /container -->




// WEBPACK FOOTER //
// ./src/app/register/register.component.html